module.exports = __webpack_public_path__ + "img/sec_phone4.c7c814a8.png";